module.exports = __webpack_public_path__ + "static/footer-logo-03c707c2aaebc3d50c8d9744d574352d.svg";